import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "common-layout"
};
const _hoisted_2 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_3 = {
  class: "demonstration",
  style: {
    "margin": "10px 0"
  }
};
const _hoisted_4 = {
  class: "dialog-footer"
};
const _hoisted_5 = {
  class: "dialog-footer"
};
const _hoisted_6 = {
  align: "left",
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_7 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_header = _resolveComponent("el-header");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_footer = _resolveComponent("el-footer");
  const _component_el_container = _resolveComponent("el-container");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
  const _component_el_descriptions = _resolveComponent("el-descriptions");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_header, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        onClick: $options.add,
        style: {
          "position": "relative",
          "left": "0px"
        }
      }, {
        default: _withCtx(() => [...(_cache[30] || (_cache[30] = [_createTextVNode("添加检测模板大项", -1)]))]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        onClick: $options.goBack,
        style: {
          "position": "relative",
          "left": "-10px"
        }
      }, {
        default: _withCtx(() => [...(_cache[31] || (_cache[31] = [_createTextVNode("上一步", -1)]))]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_input, {
        modelValue: $data.search,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.search = $event),
        style: {
          "width": "50%"
        },
        maxlength: "50",
        "show-word-limit": "",
        placeholder: "输入检测模板大项名称",
        clearable: ""
      }, {
        append: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: $options.qSearch
        }, {
          default: _withCtx(() => [...(_cache[32] || (_cache[32] = [_createTextVNode("查询", -1)]))]),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      }, 8, ["modelValue"])])]),
      _: 1
    }), _createVNode(_component_el_main, {
      style: {
        "margin-top": "-25px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table, {
        data: $data.tableData,
        style: {
          "width": "100%",
          "height": "475px"
        },
        border: "",
        "row-class-name": $options.tableRowClassName
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "操作",
          "min-width": "25%"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            size: "small",
            onClick: $event => $options.update(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[33] || (_cache[33] = [_createTextVNode("编辑", -1)]))]),
            _: 1
          }, 8, ["onClick"]), _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            size: "small",
            style: {
              "margin-left": "3px"
            },
            onClick: $event => $options.toScene(scope.row.maxtermId)
          }, {
            default: _withCtx(() => [...(_cache[34] || (_cache[34] = [_createTextVNode("查看细项 ", -1)]))]),
            _: 1
          }, 8, ["onClick"]), _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            size: "small",
            style: {
              "margin-left": "3px"
            },
            onClick: $event => $options.toAsk(scope.row.maxtermId)
          }, {
            default: _withCtx(() => [...(_cache[35] || (_cache[35] = [_createTextVNode("查看要求 ", -1)]))]),
            _: 1
          }, 8, ["onClick"]), _createVNode(_component_el_button, {
            type: "danger",
            plain: "",
            size: "small",
            style: {
              "margin-left": "3px"
            },
            onClick: $event => $options.deleteOne(scope.row.maxtermId)
          }, {
            default: _withCtx(() => [...(_cache[36] || (_cache[36] = [_createTextVNode("删除", -1)]))]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "maxtermNo",
          "min-width": "20%",
          label: "检测大项模板编号"
        }), _createVNode(_component_el_table_column, {
          prop: "maxtermName",
          "min-width": "20%",
          label: "检测大项模板名称"
        }), _createVNode(_component_el_table_column, {
          prop: "module",
          "min-width": "20%",
          label: "检测大项模块名称"
        })]),
        _: 1
      }, 8, ["data", "row-class-name"])]),
      _: 1
    }), _createVNode(_component_el_footer, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_pagination, {
        currentPage: $data.currentPage,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = $event => $data.currentPage = $event),
        "page-size": $data.pageSize,
        "onUpdate:pageSize": _cache[2] || (_cache[2] = $event => $data.pageSize = $event),
        "page-sizes": [20, 40, 60],
        small: $data.small,
        background: $data.background,
        layout: "total, sizes, prev, pager, next, jumper",
        total: $data.total,
        prev: $data.prev,
        pager: $data.pager,
        next: $data.next,
        jumper: $data.jumper,
        onSizeChange: $options.handleSizeChange,
        onCurrentChange: $options.handleCurrentChange
      }, null, 8, ["currentPage", "page-size", "small", "background", "total", "prev", "pager", "next", "jumper", "onSizeChange", "onCurrentChange"])])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_dialog, {
    modelValue: $data.dialogFormVisible,
    "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.dialogFormVisible = $event),
    title: "添加大项模板",
    "lock-scroll": false,
    width: "90%",
    style: {
      "margin-top": "30px"
    },
    draggable: ""
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createVNode(_component_el_button, {
      style: {
        "margin-top": "-40px"
      },
      onClick: _cache[13] || (_cache[13] = $event => $data.dialogFormVisible = false)
    }, {
      default: _withCtx(() => [...(_cache[43] || (_cache[43] = [_createTextVNode("关闭", -1)]))]),
      _: 1
    }), _createVNode(_component_el_button, {
      style: {
        "margin-top": "-40px"
      },
      type: "primary",
      onClick: _cache[14] || (_cache[14] = $event => $options.save('form'))
    }, {
      default: _withCtx(() => [...(_cache[44] || (_cache[44] = [_createTextVNode("确定", -1)]))]),
      _: 1
    })])]),
    default: _withCtx(() => [_createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 12
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: $data.form,
          ref: "form",
          rules: $data.rules,
          inline: true,
          "status-icon": "",
          "label-width": "160px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "具体的模块名称",
            prop: "module"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.form.module,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.module = $event),
              placeholder: "请输入具体的模块名称",
              style: {
                "width": "300px"
              },
              onkeyup: "this.value=this.value.replace(/[, ]/g,'')",
              clearable: "",
              autocomplete: "off",
              "show-word-limit": "",
              maxlength: "50",
              required: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "项目编码",
            prop: "maxtermNo"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.form.maxtermNo,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.form.maxtermNo = $event),
              placeholder: "请输入项目编码",
              style: {
                "width": "300px"
              },
              onkeyup: "this.value=this.value.replace(/[, ]/g,'')",
              clearable: "",
              autocomplete: "off",
              "show-word-limit": "",
              maxlength: "50",
              required: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "检测大项模板描述",
            prop: "maxtermDescr"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.form.maxtermDescr,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.form.maxtermDescr = $event),
              "show-word-limit": "",
              clearable: "",
              autosize: {
                minRows: 4,
                maxRows: 8
              },
              style: {
                "width": "300px"
              },
              type: "textarea",
              maxlength: "2000"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "大项的序号",
            prop: "maxtermSort"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.form.maxtermSort,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.form.maxtermSort = $event),
              placeholder: "请输入检测大项排列序号",
              style: {
                "width": "300px"
              },
              type: "number",
              oninput: "if(!/^[0-9]+$/.test(value)) value=value.replace(/\\D/g,'');if(value>200)value=200;if(value<0)value=null",
              clearable: "",
              autocomplete: "off",
              "show-word-limit": "",
              maxlength: "50",
              required: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 12
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: $data.form,
          ref: "form",
          rules: $data.rules,
          inline: true,
          "status-icon": "",
          "label-width": "160px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "检测大项模板名称",
            prop: "maxtermName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.form.maxtermName,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.form.maxtermName = $event),
              placeholder: "请输入检测大项模板名称",
              style: {
                "width": "300px"
              },
              onkeyup: "this.value=this.value.replace(/[, ]/g,'')",
              clearable: "",
              autocomplete: "off",
              "show-word-limit": "",
              maxlength: "50",
              required: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "输入框的数量",
            prop: "inputNum"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.form.inputNum,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.form.inputNum = $event),
              placeholder: "请写入输入框的数量",
              style: {
                "width": "300px"
              },
              type: "number",
              oninput: "if(!/^[0-9]+$/.test(value)) value=value.replace(/\\D/g,'');if(value>100)value=100;if(value<0)value=null",
              clearable: "",
              autocomplete: "off",
              "show-word-limit": "",
              required: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "输入框名称",
            prop: "inputName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.form.inputName,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.form.inputName = $event),
              "show-word-limit": "",
              clearable: "",
              placeholder: "请写入输入框的描述（使用@间隔）",
              autosize: {
                minRows: 4,
                maxRows: 8
              },
              style: {
                "width": "300px"
              },
              type: "textarea",
              maxlength: "200"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_form, {
      model: $data.form,
      ref: "form",
      rules: $data.rules,
      inline: true,
      "status-icon": ""
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "检测项类型",
        prop: "maxtermType"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: $data.form.maxtermType,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.form.maxtermType = $event),
          "aria-required": "true"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            border: "",
            label: 0
          }, {
            default: _withCtx(() => [...(_cache[37] || (_cache[37] = [_createTextVNode("单选", -1)]))]),
            _: 1
          }), _createVNode(_component_el_radio, {
            border: "",
            label: 1
          }, {
            default: _withCtx(() => [...(_cache[38] || (_cache[38] = [_createTextVNode("多选", -1)]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "项目类别",
        prop: "maxtermKind"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: $data.form.maxtermKind,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.form.maxtermKind = $event),
          "aria-required": "true"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            border: "",
            label: 0
          }, {
            default: _withCtx(() => [...(_cache[39] || (_cache[39] = [_createTextVNode("一般项目", -1)]))]),
            _: 1
          }), _createVNode(_component_el_radio, {
            border: "",
            label: 1
          }, {
            default: _withCtx(() => [...(_cache[40] || (_cache[40] = [_createTextVNode("重要项目", -1)]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "输入框是否必填",
        prop: "mark"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: $data.form.mark,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.form.mark = $event),
          "aria-required": "true"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            border: "",
            label: 1
          }, {
            default: _withCtx(() => [...(_cache[41] || (_cache[41] = [_createTextVNode("是", -1)]))]),
            _: 1
          }), _createVNode(_component_el_radio, {
            border: "",
            label: 0
          }, {
            default: _withCtx(() => [...(_cache[42] || (_cache[42] = [_createTextVNode("否", -1)]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    modelValue: $data.dialogFormVisibleEdit,
    "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => $data.dialogFormVisibleEdit = $event),
    title: "编辑大项模板 ",
    "lock-scroll": false,
    width: "90%",
    style: {
      "margin-top": "30px"
    },
    draggable: ""
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_5, [_createVNode(_component_el_button, {
      style: {
        "margin-top": "-40px"
      },
      onClick: _cache[26] || (_cache[26] = $event => $data.dialogFormVisibleEdit = false)
    }, {
      default: _withCtx(() => [...(_cache[51] || (_cache[51] = [_createTextVNode("关闭", -1)]))]),
      _: 1
    }), _createVNode(_component_el_button, {
      style: {
        "margin-top": "-40px"
      },
      type: "primary",
      onClick: _cache[27] || (_cache[27] = $event => $options.edit('editform'))
    }, {
      default: _withCtx(() => [...(_cache[52] || (_cache[52] = [_createTextVNode("确定", -1)]))]),
      _: 1
    })])]),
    default: _withCtx(() => [_createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 12
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: $data.editform,
          ref: "form",
          rules: $data.rules,
          inline: true,
          "status-icon": "",
          "label-width": "160px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "具体的模块名称",
            prop: "module"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.editform.module,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.editform.module = $event),
              placeholder: "请输入具体的模块名称",
              style: {
                "width": "300px"
              },
              onkeyup: "this.value=this.value.replace(/[, ]/g,'')",
              clearable: "",
              autocomplete: "off",
              "show-word-limit": "",
              maxlength: "50",
              required: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "项目编码",
            prop: "maxtermNo"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.editform.maxtermNo,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $data.editform.maxtermNo = $event),
              placeholder: "请输入项目编码",
              style: {
                "width": "300px"
              },
              onkeyup: "this.value=this.value.replace(/[, ]/g,'')",
              clearable: "",
              autocomplete: "off",
              "show-word-limit": "",
              maxlength: "50",
              required: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "检测大项模板描述",
            prop: "maxtermDescr"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.editform.maxtermDescr,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.editform.maxtermDescr = $event),
              "show-word-limit": "",
              clearable: "",
              autosize: {
                minRows: 4,
                maxRows: 8
              },
              style: {
                "width": "300px"
              },
              type: "textarea",
              maxlength: "2000"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "大项的序号",
            prop: "maxtermSort"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.editform.maxtermSort,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $data.editform.maxtermSort = $event),
              placeholder: "请输入检测大项排列序号",
              style: {
                "width": "300px"
              },
              type: "number",
              oninput: "if(!/^[0-9]+$/.test(value)) value=value.replace(/\\D/g,'');if(value>200)value=200;if(value<0)value=null",
              clearable: "",
              autocomplete: "off",
              "show-word-limit": "",
              maxlength: "50",
              required: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 12
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: $data.editform,
          ref: "form",
          rules: $data.rules,
          inline: true,
          "status-icon": "",
          "label-width": "160px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "检测大项模板名称",
            prop: "maxtermName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.editform.maxtermName,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $data.editform.maxtermName = $event),
              placeholder: "请输入检测大项模板名称",
              style: {
                "width": "300px"
              },
              onkeyup: "this.value=this.value.replace(/[, ]/g,'')",
              clearable: "",
              autocomplete: "off",
              "show-word-limit": "",
              maxlength: "50",
              required: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "输入框的数量",
            prop: "inputNum"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.editform.inputNum,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $data.editform.inputNum = $event),
              placeholder: "请写入输入框的数量",
              style: {
                "width": "300px"
              },
              type: "number",
              oninput: "if(!/^[0-9]+$/.test(value)) value=value.replace(/\\D/g,'');if(value>100)value=100;if(value<0)value=null",
              clearable: "",
              autocomplete: "off",
              "show-word-limit": "",
              required: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "输入框名称",
            prop: "inputName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.editform.inputName,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => $data.editform.inputName = $event),
              "show-word-limit": "",
              clearable: "",
              placeholder: "请写入输入框的描述（使用@间隔）",
              autosize: {
                minRows: 4,
                maxRows: 8
              },
              style: {
                "width": "300px"
              },
              type: "textarea",
              maxlength: "200"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_form, {
      model: $data.editform,
      ref: "form",
      rules: $data.rules,
      inline: true,
      "status-icon": ""
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "检测项类型",
        prop: "maxtermType"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: $data.editform.maxtermType,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $data.editform.maxtermType = $event),
          "aria-required": "true"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            border: "",
            label: 0
          }, {
            default: _withCtx(() => [...(_cache[45] || (_cache[45] = [_createTextVNode("单选", -1)]))]),
            _: 1
          }), _createVNode(_component_el_radio, {
            border: "",
            label: 1
          }, {
            default: _withCtx(() => [...(_cache[46] || (_cache[46] = [_createTextVNode("多选", -1)]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "项目类别",
        prop: "maxtermKind"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: $data.editform.maxtermKind,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => $data.editform.maxtermKind = $event),
          "aria-required": "true"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            border: "",
            label: 0
          }, {
            default: _withCtx(() => [...(_cache[47] || (_cache[47] = [_createTextVNode("一般项目", -1)]))]),
            _: 1
          }), _createVNode(_component_el_radio, {
            border: "",
            label: 1
          }, {
            default: _withCtx(() => [...(_cache[48] || (_cache[48] = [_createTextVNode("重要项目", -1)]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "输入框是否必填",
        prop: "mark"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: $data.editform.mark,
          "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => $data.editform.mark = $event),
          "aria-required": "true"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            border: "",
            label: 1
          }, {
            default: _withCtx(() => [...(_cache[49] || (_cache[49] = [_createTextVNode("是", -1)]))]),
            _: 1
          }), _createVNode(_component_el_radio, {
            border: "",
            label: 0
          }, {
            default: _withCtx(() => [...(_cache[50] || (_cache[50] = [_createTextVNode("否", -1)]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    modelValue: $data.dialogVisible,
    "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => $data.dialogVisible = $event),
    title: "查看检测记录",
    width: "60%"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_descriptions, {
      column: 2,
      border: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
        label: "创建人"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.theOne.createBy), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "创建时间"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(this.formatDate($data.theOne.createDate, "yyyy-MM-dd hh:mm:ss")), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "检测项类型"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.theOne.maxtermType === 0 ? '单选' : '多选'), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "检查值"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.theOne.maxValues), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "项目编码"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.theOne.maxtermNo), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "项目类别"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.theOne.maxtermKind == 0 ? '一般项目' : '重要项目'), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "输入框是否必填"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.theOne.mark == 0 ? '否' : '是'), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "输入框数量"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.theOne.inputNum), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "输入框描述"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.theOne.inputName), 1)]),
        _: 1
      })]),
      _: 1
    }), _cache[53] || (_cache[53] = _createElementVNode("p", {
      style: {
        "font-weight": "bold"
      }
    }, "检测大项备注：", -1)), _createElementVNode("p", null, _toDisplayString($data.theOne.drComment), 1), _cache[54] || (_cache[54] = _createElementVNode("p", {
      style: {
        "font-weight": "bold"
      }
    }, "检测大项描述：", -1)), _createElementVNode("p", null, _toDisplayString($data.theOne.maxtermDescr), 1), _cache[55] || (_cache[55] = _createElementVNode("p", {
      style: {
        "font-weight": "bold"
      }
    }, "图片和视频：", -1)), _createElementVNode("img", {
      src: $data.imgUrl,
      style: {
        "width": "100px",
        "height": "100px"
      }
    }, null, 8, _hoisted_7)])]),
    _: 1
  }, 8, ["modelValue"])]);
}